import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FragmentNavigationService } from '../../services/fragment-navigation.service';
import { SiteConfigService } from '../../services/site-config.service';

@Component({
  selector: 'app-footer',
  imports: [MatButtonModule, MatIconModule, RouterLink],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  readonly currentYear = new Date().getFullYear();

  private readonly siteConfig = inject(SiteConfigService);
  private readonly fragmentNav = inject(FragmentNavigationService);
  private readonly document = inject(DOCUMENT);

  readonly navItems = this.siteConfig.footerNavigation;
  readonly profile = this.siteConfig.profile;
  readonly contactInfo = this.siteConfig.contactInfo;

  scrollTo(fragment: string): void {
    this.fragmentNav.navigateToFragment(fragment);
  }

  scrollToTop(): void {
    this.document.defaultView?.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
